import React, { useEffect, useState } from "react";
import { Input, Button, Select } from "antd";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";

function AddCompanyStaff() {
  const navigate = useNavigate();

  const [loader, set_loader] = useState(false);
  const [errors, set_errors] = useState({});

  const [first_name, set_first_name] = useState("");
  const [last_name, set_last_name] = useState("");
  const [staff_email, set_staff_email] = useState("");
  const [staff_password, set_staff_password] = useState("");
  const [confirm_password, set_confirm_password] = useState("");
  const [phone_number, set_phone_number] = useState("");
  const [role, set_role] = useState("");
  const [roles, set_roles] = useState([]);

  const [ships, set_ships] = useState([]);
const [selectedShips, set_selectedShips] = useState([]);

  const clearError = (fieldName) => {
    if (errors[fieldName]) {
      set_errors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };


const SHIP_LIST_API = () => {
  const FORM_DATA = new FormData();
  // FORM_DATA.append("login_token", login_token);
  // FORM_DATA.append("refresh_token", refresh_token);

  post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
    if (res?.status) {
      set_ships(res?.ships || []);
    } else {
      ErrorToast("Error", res?.message);
    }
  });
};

//   const company_id = localStorage.getItem("company_id");
const user_Data = JSON.parse(localStorage.getItem("user_data"));
  const login_token = localStorage.getItem("login_token");
  const refresh_token = localStorage.getItem("refresh_token");

  const OFFICE_ROLES_API = () => {
  const FORM_DATA = new FormData();
  FORM_DATA.append("login_token", login_token);
  FORM_DATA.append("refresh_token", refresh_token);

  post(ApiURL.list_office_roles, FORM_DATA).then((res) => {
    if (res?.status === true) {
      set_roles(res?.roles || []);
    } else {
      ErrorToast("Error", res?.message);
    }
  });
};

useEffect(() => {
  OFFICE_ROLES_API();
  SHIP_LIST_API();
}, []);

  const AddCompanyStaffAPI = () => {
    set_loader(true);

    const FORM_DATA = new FormData();
    FORM_DATA.append("login_token", login_token);
    FORM_DATA.append("refresh_token", refresh_token);
    FORM_DATA.append("user_id", user_Data?.data?.company?.user_id);
    FORM_DATA.append("company_id", user_Data?.data?.company?.company_id);
    FORM_DATA.append("first_name", first_name);
    FORM_DATA.append("last_name", last_name);
    FORM_DATA.append("staff_email", staff_email);
    FORM_DATA.append("staff_password", staff_password);
    FORM_DATA.append("confirm_password", confirm_password);
    FORM_DATA.append("phone_number", phone_number);
    FORM_DATA.append("role", role);
    FORM_DATA.append("ship_ids", selectedShips.join(","));

    post(ApiURL.company_staff_registration, FORM_DATA).then((res) => {
      set_loader(false);

      if (res?.status === true) {
        SuccessToast("Success", res?.message);
        navigate("/company-staff");
      } else {
        set_errors(res?.errors || {});
        ErrorToast("Error", res?.message);
      }
    });
  };

  return (
    <div className="white-container">
      <h3>Add Company Staff</h3>

      <div className="row">
  <div className="col-6">
    <div className="input-box">
      <label>First Name</label>
      <Input
        placeholder="First Name"
        onChange={(e) => {
          set_first_name(e.target.value);
          clearError("first_name");
        }}
      />
      {errors?.first_name && (
        <span style={{ color: "red" }}>{errors.first_name}</span>
      )}
    </div>
  </div>

  <div className="col-6">
    <div className="input-box">
      <label>Last Name</label>
      <Input
        placeholder="Last Name"
        onChange={(e) => {
          set_last_name(e.target.value);
          clearError("last_name");
        }}
      />
      {errors?.last_name && (
        <span style={{ color: "red" }}>{errors.last_name}</span>
      )}
    </div>
  </div>
</div>

      <div className="row">
  <div className="col-6">
    <div className="input-box">
      <label>Email</label>
      <Input
        autoComplete="off"
        placeholder="Email"
        onChange={(e) => {
          set_staff_email(e.target.value);
          clearError("staff_email");
        }}
      />
      {errors?.staff_email && (
        <span style={{ color: "red" }}>{errors.staff_email}</span>
      )}
    </div>
  </div>

  <div className="col-6">
    <div className="input-box">
      <label>Phone Number</label>
      <Input
        autoComplete="off"
        placeholder="Phone Number"
        maxLength={10}
        value={phone_number}
        onChange={(e) => {
          const formattedValue = e.target.value.replace(/\D/g, "");
          set_phone_number(formattedValue);
          clearError("phone_number");
        }}
      />
      {errors?.phone_number && (
        <span style={{ color: "red" }}>{errors.phone_number}</span>
      )}
    </div>
  </div>
</div>

     <div className="row">
  <div className="col-6">
    <div className="input-box">
      <label>Password</label>
      <Input.Password
      autoComplete="new-password"
        placeholder="Password"
        onChange={(e) => {
          set_staff_password(e.target.value);
          clearError("staff_password");
        }}
      />
      {errors?.staff_password && (
        <span style={{ color: "red" }}>{errors.staff_password}</span>
      )}
    </div>
  </div>

  <div className="col-6">
    <div className="input-box">
      <label>Confirm Password</label>
      <Input.Password
      autoComplete="new-password"
        placeholder="Confirm Password"
        onChange={(e) => {
          set_confirm_password(e.target.value);
          clearError("confirm_password");
        }}
      />
      {errors?.confirm_password && (
        <span style={{ color: "red" }}>{errors.confirm_password}</span>
      )}
    </div>
  </div>
</div>

     {/* <div className="row">
  <div className="col-6">
    <div className="input-box">
      <label>Role</label>
     <Select
  placeholder="Select Role"
  style={{ width: "100%" }}
  onChange={(value) => set_role(value)}
>
  {roles.map((item, index) => (
    <Select.Option key={index} value={item.value}>
      {item.label}
    </Select.Option>
  ))}
</Select>
    </div>
  </div>
</div>

<div className="row">
  <div className="col-6">
    <div className="input-box">
      <label>Ships</label>

      <Select
        mode="multiple"
        placeholder="Select Ships"
        style={{ width: "100%" }}
        value={selectedShips}
        onChange={(value) => set_selectedShips(value)}
      >
        {ships.map((ship) => (
          <Select.Option key={ship.id} value={ship.id}>
            {ship.vessel_name}
          </Select.Option>
        ))}
      </Select>

    </div>
  </div>
</div> */}

<div className="row">

  <div className="col-6">
    <div className="input-box">
      <label>Role</label>

      <Select
        placeholder="Select Role"
        style={{ width: "100%" }}
        onChange={(value) => {
          set_role(value);
          clearError("role");
        }}
      >
        {roles.map((item, index) => (
          <Select.Option key={index} value={item.value}>
            {item.label}
          </Select.Option>
        ))}
      </Select>
      {errors?.role && (
        <span style={{ color: "red" }}>{errors.role}</span>
      )}

    </div>
  </div>

  <div className="col-6">
    <div className="input-box">
      <label>Ships</label>

      <Select
        mode="multiple"
        placeholder="Select Ships"
        style={{ width: "100%" }}
        value={selectedShips}
        onChange={(value) => {
          set_selectedShips(value);
          clearError("ship_ids");
        }}
      >
        {ships.map((ship) => (
          <Select.Option key={ship.id} value={ship.id}>
            {ship.vessel_name}
          </Select.Option>
        ))}
      </Select>
      {errors?.ship_ids && (
        <span style={{ color: "red" }}>{errors.ship_ids}</span>
      )}

    </div>
  </div>

</div>

      <br />

      <Button
        loading={loader}
        type="primary"
        className="save_btn"
        onClick={AddCompanyStaffAPI}
      >
        Save
      </Button>
    </div>
  );
}

export default AddCompanyStaff;